import React from 'react';
import styled from 'styled-components';
import { printThemeVars } from '../../components/utils/helpers';

import { lightTheme, darkTheme } from '@spotify-internal/encore-web';

export type ValidThemes = 'encoreLight' | 'encoreDark';

const themeMap: Record<ValidThemes, { values: object }> = {
  encoreLight: {
    values: Object.assign(
      {},
      lightTheme.base,
      { warning: lightTheme.warning },
      { inverted: lightTheme.invertedDark },
    ),
  },
  encoreDark: {
    values: Object.assign(
      {},
      darkTheme.base,
      { warning: darkTheme.warning },
      { inverted: lightTheme.invertedLight },
    ),
  },
};

const ThemedGroup = styled.div<{ customTheme: { values: object } }>`
  ${({ customTheme }) => printThemeVars(customTheme)}
`;

const UnthemedGroup = styled.div``;

export const getThemeValues = (themeName: ValidThemes) => themeMap[themeName];

const Theme = ({
  themeName,
  children,
}: {
  themeName?: ValidThemes;
  children: React.ReactNode;
}) => {
  if (!themeName || !getThemeValues(themeName)) {
    return <UnthemedGroup>{children}</UnthemedGroup>;
  }

  return (
    <ThemedGroup customTheme={getThemeValues(themeName)}>
      {children}
    </ThemedGroup>
  );
};

export default Theme;
